
export  function roundToTwoDecimals(toRound: number): number {
    return Math.round(toRound * 100) / 100;
}

export function floor(toFloor: number): number {
    return Math.floor(toFloor);
}

